<div class="alert alert-info-box alert-block alert-icon"
     [class.alert-info-message]="infoPanel?.info">
    <i class="icon icon-info"></i>
    {{infoPanel?.textKey | localize}}
    <ng-content select="[role=body]"></ng-content>
</div>
